import { memo } from 'react';
import { Box, UnstyledButton } from '@mantine/core';
import { Icon } from '@/ui';
import classes from './ChangelogButton.module.css';

export const ChangelogButton = memo(() => {
  return (
    <Box className={classes.changelogButtonContainer}>
      <UnstyledButton data-canny-changelog className={classes.changelogButton}>
        <Icon color="var(--mantine-color-text)" name="speakerphone" />
      </UnstyledButton>
    </Box>
  );
});
